import { defineStore } from 'pinia'

function generateUUIDv4(): string {
  const buf = new Uint8Array(16)
  crypto.getRandomValues(buf)

  buf[6] = (buf[6]! & 0x0f) | 0x40
  buf[8] = (buf[8]! & 0x3f) | 0x80

  const hex = [...buf].map(b => b.toString(16).padStart(2, '0')).join('')
  return (
    hex.slice(0, 8) + '-'
    + hex.slice(8, 12) + '-'
    + hex.slice(12, 16) + '-'
    + hex.slice(16, 20) + '-'
    + hex.slice(20)
  )
}

export const useAnonymousStore = defineStore(
  '_cam_anonymous_id',
  () => {
    const anonymousId = ref<string | null>(null)

    const ensureAnonymousId = () => {
      if (!anonymousId.value) {
        anonymousId.value = generateUUIDv4()
      }
    }

    return {
      anonymousId,
      ensureAnonymousId,
    }
  },
  {
    // localStorage で永続化する (#596 — authInfo.ts のコメント参照)。
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
